export default __webpack_public_path__ + "static/media/connected-network.810cddbd.svg";